"use client";

import { usePathname } from "next/navigation";
import { useEffect, useState, useTransition } from "react";
import { toggleDraftMode } from "~www/actions/toggleDraftMode";

export const SanityPreviewBar = () => {
  const path = usePathname();
  const [pending, startTransition] = useTransition();
  const [isInIframe, setIsInIframe] = useState(false);

  useEffect(() => {
    // TODO stop suppressing this warning (don't replicate this!)
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setIsInIframe(window.self !== window.top);
  }, []);

  if (isInIframe) {
    return null;
  }

  const disable = () =>
    startTransition(async () => {
      await toggleDraftMode(false);
      // Fully reload the page to avoid out-of-sync state
      window.location.href = path;
    });

  return (
    <div className="fixed right-0 bottom-1 left-0 z-[100] px-2 md:bottom-2 md:px-4">
      <div className="mx-auto max-w-96 rounded-md border border-zinc-200 bg-zinc-100/80 p-2 backdrop-blur-sm dark:border-zinc-800 dark:bg-zinc-900/80">
        <div className="flex items-center">
          <div className="flex-1">
            <p className="text-xs text-zinc-700 dark:text-zinc-300">
              {pending
                ? "Disabling draft mode..."
                : "Viewing the website in preview mode."}
            </p>
          </div>
          {!pending && (
            <button
              className="ml-4 rounded bg-red-600 px-2 py-1 font-medium text-white text-xs hover:bg-red-700 disabled:opacity-50"
              onClick={disable}
              type="button"
            >
              Exit
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
